module.exports = "<p>extraction-product-program works!</p>\r\n"